import { FaAccessibleIcon, FaBars, FaSearch, FaSitemap } from "react-icons/fa";
import logo from "./img/emblem-dark.png";
import digital from "./img/digital-india.png";
import "./Navbar.css";
import { useState , useEffect} from "react";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [submenuOpen, setSubmenuOpen] = useState({
    about: false,
    citizen: false,
    documents: false,
    schemes: false,
    notices: false,
    rti: false,
    publications: false,  
    media: false,         
  });
  
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 750);
  const handleMouseEnter = (submenu) => {
    setSubmenuOpen((prev) => ({
      ...prev,
      [submenu]: true,
    }));
  };

  const handleMouseLeave = (submenu) => {
    setSubmenuOpen((prev) => ({
      ...prev,
      [submenu]: false,
    }));
  };

  const toggleSubmenu = (submenu) => {
    setSubmenuOpen((prev) => ({
      ...prev,
      [submenu]: !prev[submenu],
    }));
  };

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth > 750);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleMenu = () => {
    if (isDesktop) {
      setMenuOpen(!menuOpen);
    }
  };
  return (
    <header className="navbar-container">
      {/* Top Bar */}
      <div className="top-bar">
        <div className="top-left">
        <span className="gov-text">महाराष्ट्र शासन</span>
        <div className="bar"></div>
        <span className="gov-eng-text">GOVERNMENT OF MAHARASHTRA</span>
        </div>
        <div className="top-links">
          
          <FaSearch className="top-icon"/>
          <FaSitemap className="top-icon"/>
          <FaAccessibleIcon className="top-icon"/>
          <a href="#" className="top-link">ENGLISH</a>
        </div>
      </div>

      {/* Main Navbar */}
      <div className="main-navbar">
        <div className="navbar-logo">
          <img src={logo} alt="Government Logo" className="gov-logo" />
          <div className="logo-name">
            <h1 className="district-name">पंचायत समिती जळगाव (जा) जिल्हा बुलढाणा</h1>
            <h2 className="district-eng-name">Panchayat Samiti Jalgaon (J) Dist Buldhana</h2>
          </div>
        </div>
        <img src={digital} alt="Digital India" className="digital-india-logo" />
      </div>

      {/* Navigation Menu */}
      <nav className="nav-menu">
      <button className="menu-button" onClick={() => setMenuOpen(!menuOpen)}>
        <FaBars size={24} />
      </button>

      <ul className={`nav-links ${menuOpen ? "open" : ""}`}>
        <li className="nav-item">Home</li>

        <li
          className="nav-item"
          onMouseEnter={() => handleMouseEnter("about")}
          onMouseLeave={() => handleMouseLeave("about")}
          onClick={() => toggleSubmenu("about")}
        >
          About Department ▼
          <ul className={`submenu ${submenuOpen.about ? "open" : ""}`}>
            <li className="submenu-item">Introduction</li>
            <li className="submenu-item">Vision & Mission</li>
            <li className="submenu-item">Objectives & Functions</li>
            <li className="submenu-item">Administrative Setup</li>
            <li className="submenu-item">Awards & Appreciations</li>
            <li className="submenu-item">Who's Who</li>

          </ul>
        </li>

        <li
          className="nav-item"
          onMouseEnter={() => handleMouseEnter("citizen")}
          onMouseLeave={() => handleMouseLeave("citizen")}
          onClick={() => toggleSubmenu("citizen")}
        >
          Citizen’s Corner ▼
          <ul className={`submenu ${submenuOpen.citizen ? "open" : ""}`}>
            <li className="submenu-item">Services</li>
            <li className="submenu-item">Forms</li>
            <li className="submenu-item">Grievance Redressal</li>
          </ul>
        </li>

        <li className="nav-item">Directory</li>
        <li className="nav-item">Departments</li>

        <li
          className="nav-item"
          onMouseEnter={() => handleMouseEnter("documents")}
          onMouseLeave={() => handleMouseLeave("documents")}
          onClick={() => toggleSubmenu("documents")}
        >
          Documents ▼
          <ul className={`submenu ${submenuOpen.documents ? "open" : ""}`}>
            <li className="submenu-item">Annual Reports</li>
            <li className="submenu-item">Office Orders</li>
            <li className="submenu-item">Circulars / Notifications</li>
            <li className="submenu-item">Acts & Rules</li>
          </ul>
        </li>

        <li
          className="nav-item"
          onMouseEnter={() => handleMouseEnter("schemes")}
          onMouseLeave={() => handleMouseLeave("schemes")}
          onClick={() => toggleSubmenu("schemes")}
        >
          Schemes/Programmes ▼
          <ul className={`submenu ${submenuOpen.schemes ? "open" : ""}`}>
            <li className="submenu-item">State Government</li>
            <li className="submenu-item">Central Government</li>
          </ul>
        </li>

        <li
          className="nav-item"
          onMouseEnter={() => handleMouseEnter("notices")}
          onMouseLeave={() => handleMouseLeave("notices")}
          onClick={() => toggleSubmenu("notices")}
        >
          Notices ▼
          <ul className={`submenu ${submenuOpen.notices ? "open" : ""}`}>
            <li className="submenu-item">Recruitments</li>
            <li className="submenu-item">Events</li>
            <li className="submenu-item">Past Events</li>
            <li className="submenu-item">Announcements (Genral)</li>
            <li className="submenu-item">Announcements (Budgetary)</li>
            <li className="submenu-item">Tenders</li>
          </ul>
        </li>

        <li
          className="nav-item"
          onMouseEnter={() => handleMouseEnter("rti")}
          onMouseLeave={() => handleMouseLeave("rti")}
          onClick={() => toggleSubmenu("rti")}
        >
          RTI ▼
          <ul className={`submenu ${submenuOpen.rti ? "open" : ""}`}>
            <li className="submenu-item">RTI Documents</li>
            <li className="submenu-item">RTI Contacts (PIOs / APIOs / AAs)</li>
          </ul>
        </li>
      </ul>
      {/* Sidebar and Overlay */}
{isDesktop && (
  <>
    <div className={`overlay ${menuOpen ? "open" : ""}`} onClick={() => setMenuOpen(false)}></div>
    <div className={`sidebar ${menuOpen ? "open" : ""}`}>
      <ul className="sidebar-links">
        
      <li
          className="nav-item"
          onMouseEnter={() => handleMouseEnter("publications")}
          onMouseLeave={() => handleMouseLeave("publications")}
          onClick={() => toggleSubmenu("publications")}
        >
          Publications ▼
          <ul className={`submenu ${submenuOpen.publications ? "open" : ""}`}>

            <li className="submenu-item">Training Manuals</li>
          </ul>
        </li>
        
      <li
          className="nav-item"
          onMouseEnter={() => handleMouseEnter("media")}
          onMouseLeave={() => handleMouseLeave("media")}
          onClick={() => toggleSubmenu("media")}
        >
          Media corner ▼
          <ul className={`submenu ${submenuOpen.media ? "open" : ""}`}>

            <li className="submenu-item">News</li>
            <li className="submenu-item">Photo Gallery</li>
          </ul>
        </li>
        
      <li
          className="nav-item"
          
        >
          Places/Centers        </li>
      </ul>
    </div>
  </>
)}
    </nav>
    </header>
  );
}
